import { render, staticRenderFns } from "./changeFeeRootList.vue?vue&type=template&id=22c7b116&scoped=true"
import script from "./changeFeeRootList.vue?vue&type=script&lang=js"
export * from "./changeFeeRootList.vue?vue&type=script&lang=js"
import style0 from "./changeFeeRootList.vue?vue&type=style&index=0&id=22c7b116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c7b116",
  null
  
)

export default component.exports